import { i, c as o } from "../crc32-LCGpXEbE.js";
import c from "./otasdk.js";
import { getInitialLanguage as l } from "./lang-utils.js";
import { s as u, a as f } from "../i18nInstance-D20fwFYr.js";
import "../constants-IFi5pBQh.js";
const m = {
  type: "3rdParty",
  init(t) {
    u(t.options.react), f(t);
  }
}, g = ({ useSuspense: t, enableDebug: e }) => ({
  react: {
    hashTransKey(n) {
      return o.str(n);
    },
    useSuspense: t
  },
  debug: e,
  initImmediate: !0,
  fallbackLng: "EN",
  interpolation: {
    escapeValue: !1
  }
});
function b({
  cdnUrl: t,
  useSuspense: e = !0,
  enableDebug: n = !1
}) {
  const a = new c(t), r = l(), s = g({ useSuspense: e, enableDebug: n });
  return i.use(a).use(m).init({ ...s, lng: r }), i;
}
export {
  b as default
};
